import type { ActiveProjectsConfig } from '../types';

/**
 * Normalise the persisted active-projects configuration to the current
 * `{ excludeCompleted, selectedStages }` shape, converting any legacy
 * `{ excludeStages, includeOnlyStages }` payloads on the way through.
 */
export function normalizeActiveProjectsConfig(config: any): ActiveProjectsConfig {
  if (!config) return { excludeCompleted: true, selectedStages: [] };

  // If it's already in the new format, return as-is
  if (config.selectedStages !== undefined) {
    return config;
  }

  // Convert old format to new format
  if (config.excludeStages || config.includeOnlyStages) {
    return {
      excludeCompleted: config.excludeCompleted ?? true,
      selectedStages: config.includeOnlyStages || [],
    };
  }

  // Default format
  return { excludeCompleted: true, selectedStages: [] };
}
